module.exports = __webpack_public_path__ + "static/Cookies-b94ae01ef364fdca9b4320c428a92cc9.png";